// The context menu of the main window: text entries everywhere, plus the compta screen's document and page entries
// while it is mounted (`getLogic` returns its DCHost logic, null on login / password screens).
import { useCallback, useEffect, useRef } from 'react';
import { ContextMenu } from '@rimocore/shared/ctx/ContextMenu';
import { registerContextMenu } from '@rimocore/shared/ctx/registry';
import { RimoPreview } from '@rimocore/shared/preview/RimoPreview';
import { accountProvider, appEntries, binderProvider, comptaProvider, selectionEntries, type ComptaLogic } from './compta';
import { cardProvider } from '../cards/CardStartDialog';
import { LayeredPreview } from '../layers/LayeredPreview';

export function AppContextMenu({ getLogic }: { getLogic: () => ComptaLogic | null }) {
  const rebuild = useRef<() => void>(() => {});
  const logic = useRef(getLogic); logic.current = getLogic;
  useEffect(() => registerContextMenu(comptaProvider(() => logic.current(), () => rebuild.current()), 50), []);
  useEffect(() => registerContextMenu(cardProvider, 40), []);
  useEffect(() => registerContextMenu(accountProvider(() => logic.current()), 45), []);
  useEffect(() => registerContextMenu(binderProvider, 44), []);
  const onRebuild = useCallback((fn: () => void) => { rebuild.current = fn; }, []);
  return (
    <ContextMenu onRebuild={onRebuild}
      selectionExtra={(ev) => selectionEntries(ev, logic.current())}
      fallback={() => appEntries()}
      renderView={(v, close) => { const xml = /\(XML\)$|\.xml$/i.test(v.title ?? ''); // the e-invoice (docFiles.fileList)
        if (v.ref && !xml) return <LayeredPreview documentId={v.ref} url={v.url} title={v.title || 'Dokument'} onClose={close} />; // ES: with its notes layer
        return <RimoPreview source={v.url} fileName={xml ? (v.title ?? '').replace(/\s*\(XML\)$/i, '') + '.xml' : v.title || 'Dokument'} mimeType={xml ? 'application/xml' : 'application/pdf'} onClose={close} />; }} />
  );
}
